import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedSeats: [],
    passengerDetails: [],
    ticketType: "oneWay",
    totalPrice: 0,
    bookingResult: null,
    isProcessing: false,
    error: null,
    // Payment simulation state
    paymentResult: null,
    paymentProcessing: false,
    paymentError: null,
};

const bookingSlice = createSlice({
    name: "booking",
    initialState,
    reducers: {
        setSelectedSeats(state, action) {
            state.selectedSeats = action.payload;
        },
        setPassengerDetails(state, action) {
            state.passengerDetails = action.payload;
        },
        setTicketType(state, action) {
            state.ticketType = action.payload;
        },
        setTotalPrice(state, action) {
            state.totalPrice = action.payload;
        },
        setBookingResult(state, action) {
            state.bookingResult = action.payload;
        },
        setProcessing(state, action) {
            state.isProcessing = action.payload;
        },
        setBookingError(state, action) {
            state.error = action.payload;
        },
        setPaymentResult(state, action) {
            state.paymentResult = action.payload;
        },
        setPaymentProcessing(state, action) {
            state.paymentProcessing = action.payload;
        },
        setPaymentError(state, action) {
            state.paymentError = action.payload;
        },
        resetBooking(state) {
            return initialState;
        },
    },
});

export const {
    setSelectedSeats,
    setPassengerDetails,
    setTicketType,
    setTotalPrice,
    setBookingResult,
    setProcessing,
    setBookingError,
    setPaymentResult,
    setPaymentProcessing,
    setPaymentError,
    resetBooking,
} = bookingSlice.actions;

export default bookingSlice.reducer;
